import {DodgerBlueColor} from '../../cmsMainStyle'

const fileZoneContentStyle = theme => ({

	fileList: {
		marginTop: theme.spacing(2),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
	},

	attachmentBtn: {
		margin: "2px",
	},

	approveText: {
		'& .MuiTextField-root': {
			marginBottom: theme.spacing(1),
		},

		marginLeft: theme.spacing(8),
	},

	approveTextDivider: {
		marginTop: theme.spacing(2),
	},


	fileUploadBtnArea: {
		textAlign: "center",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	fileUploadBtn: {
		backgroundColor: DodgerBlueColor[11],
	},

	uploadErrorMsg: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(2)
	}
})

export {fileZoneContentStyle}